/* =============================================================================
   hd-team-combos.js —— 设计台「Your product」面板的规格卡   2026-10-14
   -----------------------------------------------------------------------------
   ── 为什么 ──
   设计台原来只在面板上写一行小字「Designing: <色> / <码>」。现在换成一张卡：
     · 从目录页带过来的「色 x 码」组合 ⇒ 一行一组（多组 = Team）
     · 没有组合（从「我的设计」进来 / 手输 URL）⇒ 用设计台当前锁定的色/码显示**一行**
   ── 数据 ──
   sessionStorage['hdTeamCombos'] = { pid: 71, items: [{c:'Black', s:'M', q:1, hex:'#111111'}, …] }
     · pid 与当前 product_id 不一致 ⇒ 视为无效（忽略 + 清掉，防串味）
     · 兜底数据源 window.__dsPick = { color, size, hex }（由 design-canvas 在 loadProduct 里挂上）
   ── 交互 ──
   色 / 码**只读**；只有**数量**可改（− / +，最小 1）。一行时不显示标题。
   ── 位置 ──
   插在 #pfmStage 末尾（= Save design / My designs 那两行按钮的下方）。
   ============================================================================= */
(function () {
  'use strict';
  var KEY = 'hdTeamCombos';
  var items = [];
  var previewColor = '';      /* 画布当前预览的色（点色块切换） */

  function q(id) { return document.getElementById(id); }
  function curPid() {
    try { return String(new URLSearchParams(location.search).get('product_id') || ''); } catch (e) { return ''; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* 目录页写入的组合（pid 必须匹配，否则丢弃 —— 换产品时不留上一件的残留） */
  function loadStore() {
    var out = [];
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return out;
      var o = JSON.parse(raw);
      if (!o || String(o.pid || '') !== curPid()) { try { sessionStorage.removeItem(KEY); } catch (e) { } return out; }
      (o.items || []).forEach(function (it) {
        if (!it || !it.c || !it.s) return;
        if (out.some(function (x) { return x.c === String(it.c) && x.s === String(it.s); })) return;
        out.push({ c: String(it.c), s: String(it.s), q: Math.max(1, parseInt(it.q, 10) || 1), hex: String(it.hex || '') });
      });
    } catch (e) { }
    return out;
  }
  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify({ pid: curPid(), items: items })); } catch (e) { }
  }
  /* 兜底：设计台本次锁定的色 / 码（没有组合数据时的唯一一行） */
  function fallback() {
    var out = [];
    try {
      var p = window.__dsPick || {};
      if (p.color || p.size) out.push({ c: String(p.color || ''), s: String(p.size || ''), q: 1, hex: String(p.hex || '') });
    } catch (e) { }
    return out;
  }

  function build() {
    /* 🔴 插入点 = **按钮行之后**（那一行 Save design / My designs 的 .pfm-stage-row）。
       #pfmStage 本身是「产品图 | 面板」的 flex 容器 —— 直接 appendChild 会变成
       第三个 flex item ⇒ 卡片被挤到产品图下方（用户实测反馈）。 */
    var _btn = q('pfmBtnSaveDesign');
    var host = _btn ? _btn.parentElement : null;
    if (!host) host = document.querySelector('#pfmStage .pfm-stage-panel');
    if (!host || q('hdTeamCard')) return;
    var d = document.createElement('div');
    d.id = 'hdTeamCard';
    /* 站点底色偏浅、面板内也有装饰 ⇒ 不透明白底（同目录页那块的样式口径） */
    d.style.cssText = 'margin-top:16px;background:#fff;border:1px solid #E5E7EB;border-radius:12px;padding:12px 14px';
    d.innerHTML =
      '<div id="hdTeamHead" style="display:flex;align-items:baseline;gap:8px;margin-bottom:8px">'
      + '<span style="font-size:.82rem;font-weight:800;color:#1A1230">Your combos</span>'
      + '<span id="hdTeamCnt" style="font-size:.72rem;font-weight:600;color:#7C3AED"></span></div>'
      + '<div id="hdTeamRows" style="display:flex;flex-direction:column;gap:6px"></div>';
    host.insertAdjacentElement('afterend', d);   /* 紧跟按钮行 ✅ 在面板内部 */
  }

  function render() {
    var box = q('hdTeamRows');
    if (!box) return;
    var multi = items.length > 1;
    var head = q('hdTeamHead'), cnt = q('hdTeamCnt');
    if (head) head.style.display = multi ? 'flex' : 'none';   /* 一行时不显示标题 */
    if (cnt) cnt.textContent = multi ? (items.length + ' combos') : '';

    box.innerHTML = '';
    items.forEach(function (it, idx) {
      var row = document.createElement('div');
      var _isPrev = (previewColor && it.c === previewColor);
      row.style.cssText = 'display:flex;align-items:center;gap:10px;background:' + (_isPrev ? '#FAF5FF' : '#fff')
        + ';border:1px solid ' + (_isPrev ? '#C4B5FD' : '#E5E7EB') + ';border-radius:10px;padding:7px 10px';
      row.innerHTML =
        /* 2026-10-14：色块 + 色名**合并成一个大的可点热区**（原来只有 18px 的色块可点 ⇒ 点不中）。
           负 margin 把 padding 撑出去 ⇒ 热区变大但**行高不变**；hover 由下面 JS 给反馈。 */
        '<span data-color="' + esc(it.c) + '" title="Preview this color" '
        + 'style="flex:0 1 172px;min-width:76px;display:flex;align-items:center;gap:9px;cursor:pointer;'
        + 'padding:6px 9px;margin:-6px 0 -6px -9px;border-radius:8px">'
        + '<span style="flex:0 0 auto;width:20px;height:20px;border-radius:6px;border:1px solid rgba(0,0,0,.12);background:'
        + esc(it.hex || '#F4F4F5') + '"></span>'
        + '<span style="flex:0 1 auto;min-width:0;font-size:.82rem;font-weight:600;color:#1A1230;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + esc(it.c) + '</span>'
        + '</span>'
        + '<span style="flex:0 0 auto;color:#9CA3AF;font-size:.75rem">|</span>'
        + '<span style="flex:0 0 auto;width:32px;white-space:nowrap;font-size:.82rem">' + esc(it.s) + '</span>';

      var st = document.createElement('span');
      st.style.cssText = 'flex:0 0 auto;margin-left:auto;display:flex;align-items:center;gap:8px';
      var mi = document.createElement('button'), qn = document.createElement('span'), pl = document.createElement('button');
      mi.type = 'button'; mi.textContent = '\u2212'; mi.setAttribute('aria-label', 'Decrease quantity');
      pl.type = 'button'; pl.textContent = '+'; pl.setAttribute('aria-label', 'Increase quantity');
      [mi, pl].forEach(function (b) {
        b.style.cssText = 'width:22px;height:22px;border:1px solid #E5E7EB;background:#fff;border-radius:6px;color:#6B7280;font-size:13px;line-height:1;cursor:pointer;font-family:inherit';
      });
      qn.textContent = it.q;
      qn.style.cssText = 'min-width:18px;text-align:center;font-size:.82rem;font-weight:600';
      mi.onclick = function () { items[idx].q = Math.max(1, items[idx].q - 1); render(); save(); };
      pl.onclick = function () { items[idx].q += 1; render(); save(); };
      st.appendChild(mi); st.appendChild(qn); st.appendChild(pl);
      row.appendChild(st);
      /* 点色块 = 把画布底板换成这个色（设计内容不动）—— 走 design-canvas 暴露的 window.__hdSwapColor */
      var _chip = row.querySelector('[data-color]');
      if (_chip) {
        /* hover 反馈（内联做不到 :hover ⇒ 用 mouseenter/leave；只动这一个热区） */
        _chip.onmouseenter = function () { try { _chip.style.background = '#F5F3FF'; } catch (e) { } };
        _chip.onmouseleave = function () { try { _chip.style.background = ''; } catch (e) { } };
      }
      if (_chip) _chip.onclick = function () {
        var nm = _chip.getAttribute('data-color');
        if (typeof window.__hdSwapColor === 'function' && window.__hdSwapColor(nm)) {
          previewColor = nm;
          render();
        }
      };
      box.appendChild(row);
    });
  }

  /* 2026-10-14（性能 ③）：规格卡渲染后**后台串行**为每行色预取「该色成品图」——
     等用户真去点的时候缓存已就绪 ⇒ 瞬时切换（否则首次点某个色要等一次 API 往返）。
     串行 + 间隔 600ms，避免和首屏抢带宽；幂等（内部有缓存去重）。 */
  function preloadColors() {
    /* 2026-10-14（提速）：把「用户选的这几行色」交给设计台预热成品图（点的时候图已在缓存里）。
       ⚠️ 这里**不做**任何时序处理 —— boot() 跑得早、产品还没就绪，交给 __hdPreloadColors 的
       待办队列（它在 hd-canvas.js 里，loadProduct 完成后自动消费）。 */
    var names = (items || []).map(function (it) { return it.c; });
    try {
      if (typeof window.__hdPreloadColors === 'function') { window.__hdPreloadColors(names); return; }
      /* 兜底：极端情况下退回逐个直调（可能被 product 未就绪挡掉，但无害） */
      if (typeof window.__hdPreloadColor === 'function') names.forEach(function (n) { try { window.__hdPreloadColor(n); } catch (e) { } });
    } catch (e) { }
  }

  /* __dsPick 由 loadProduct 异步挂上 ⇒ 轮询等它（最多 ~20s）；已有组合数据则不用等 */
  var tries = 0;
  function boot() {
    tries++;
    var stored = loadStore();
    var host = q('pfmStage');
    var hasPick = !!(window.__dsPick && (window.__dsPick.color || window.__dsPick.size));
    if (host && (stored.length || hasPick)) {
      items = stored.length ? stored : fallback();
      if (!items.length) return;
      if (!previewColor && items.length) previewColor = items[0].c;   /* 首屏预览色 = 第一行（= 设计台 color 参数） */
      build();
      render();
      preloadColors();      /* 2026-10-14（性能 ③）：后台预热每一行的成品图 */
      try { window.__hdTeamCombos = { items: items, save: save }; } catch (e) { }
      return;
    }
    if (tries < 40) setTimeout(boot, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* 从 bfcache 回来 / 目录页改了选择再回来 ⇒ 重读一遍 */
  window.addEventListener('pageshow', function () {
    var stored = loadStore();
    if (!stored.length) return;
    items = stored;
    if (q('hdTeamCard')) { render(); } else { boot(); }
  });
})();
